var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { Button, Dragger, Loader, NoData } from "oned";
import { AmplitudeEventName, ProblemLevel, StepType } from "@common/enums/base";
import './index.less';
import SvgImage from "../svgImage";
import { getCurrentEnv, getLocationId, isMobile, sendAmplitude_Default } from "@common/utils";
import { isEmpty } from "lodash-es";
import PubSub from "@common/utils/pubsub";
import HowToVideo from "../howToVideo";
var DifferentIssue = ProblemLevel.DifferentIssue;
var DuplicateCheckList = inject(ProblemBusiness)(observer(function (props) {
    var jump = props.jump, setLevel = props.setLevel, setOriginWO = props.setOriginWO, currentUser = props.currentUser, serviceCategoryId = props.serviceCategoryId, duplicateWOList = props.duplicateWOList, computeDuplicateWOList = props.computeDuplicateWOList, toggleWOAttachmentShow = props.toggleWOAttachmentShow, screenWidth = props.screenWidth, screenLimit = props.screenLimit, clientId = props.clientId, duplicateWOsLoading = props.duplicateWOsLoading, setCommonDupCheck = props.setCommonDupCheck, setHowToVideoVisible = props.setHowToVideoVisible, videoURL = props.videoURL, howToVideoVisible = props.howToVideoVisible;
    var handleJump = function () {
        recallCheck();
        setCommonDupCheck(false);
        sendAmplitude_Default(AmplitudeEventName.RSPDuplicate_DifferentIssue, {
            env: getCurrentEnv(),
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            locationId: getLocationId(),
            clientId: clientId,
        });
    };
    var handleOriginWO = function (wo) {
        setLevel(ProblemLevel.DuplicateOriginWO);
        setOriginWO(wo);
        setCommonDupCheck(true);
        jump(StepType.Detail);
        sendAmplitude_Default(AmplitudeEventName.RSPDuplicate_RelatedIssue, {
            env: getCurrentEnv(),
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            locationId: getLocationId(),
            clientId: clientId,
            woId: wo.woId,
        });
    };
    var handleScreenWidth = function () {
        var setScreenWidth = props.setScreenWidth;
        var zoom = document.documentElement.clientWidth;
        setScreenWidth(zoom);
    };
    useEffect(function () {
        scrollTop();
        handleScreenWidth();
        window.addEventListener('resize', handleScreenWidth);
        return window.removeEventListener('resize', handleScreenWidth);
    }, []);
    var scrollTop = function () {
        PubSub.notify('scrollto', 0);
    };
    useEffect(function () {
        computeDuplicateWOList(duplicateWOList);
    }, [screenWidth]);
    var recallCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        var setProblemLevel, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setProblemLevel = props.setProblemLevel;
                    return [4 /*yield*/, getRecallWOs()];
                case 1:
                    res = _a.sent();
                    if (!res.body || isEmpty(res.body)) {
                        if (videoURL) {
                            handleVideoURL();
                        }
                        else {
                            jumpAction();
                        }
                    }
                    else {
                        setProblemLevel(ProblemLevel.RecallCheck);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var jumpAction = function () {
        jump(StepType.Detail);
        setLevel(DifferentIssue);
    };
    var getRecallWOs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var setDuplicateWOsLoading, isAliasingView, levelOneId, getRecallWOList, levelThreeId, serviceCodeId, query, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDuplicateWOsLoading = props.setDuplicateWOsLoading, isAliasingView = props.isAliasingView, levelOneId = props.levelOneId, getRecallWOList = props.getRecallWOList, levelThreeId = props.levelThreeId, serviceCodeId = props.serviceCodeId;
                    setDuplicateWOsLoading(true);
                    query = {
                        locationId: getLocationId(),
                        residentId: currentUser.residentId,
                        serviceCategoryId: isAliasingView ? serviceCategoryId : levelOneId,
                        serviceCodeId: isAliasingView ? serviceCodeId : levelThreeId
                    };
                    return [4 /*yield*/, getRecallWOList(query).finally(function () {
                            setDuplicateWOsLoading(false);
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    }); };
    var handleVideoURL = function () {
        if (isMobile) {
            setLevel(ProblemLevel.HowToVideo);
        }
        else {
            setHowToVideoVisible(true);
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Loader, { page: true, visible: duplicateWOsLoading }),
        React.createElement("div", { className: "duplicate-check" },
            React.createElement("div", { className: "dsm-card" },
                React.createElement("div", { className: "dsm-card-body" },
                    React.createElement("div", { className: 'row' },
                        React.createElement("div", { className: 'col-12' },
                            React.createElement("h2", { className: 'problem-title' },
                                React.createElement("b", null, "Duplicate check"))),
                        React.createElement("div", { className: "col-12 text-mobile-adapt f16" }, "We found similar maintenance requests at your location. To ensure fast service, we try and reduce duplicate requests."),
                        React.createElement("div", { className: "col-12 mt-4" },
                            React.createElement("b", { className: "f20" }, "Is this request the same as any of the request(s) below?"))))),
            !isEmpty(duplicateWOList) && duplicateWOList.map(function (wo) { return (React.createElement(DuplicateWOItem, { wo: wo, handleOriginWO: handleOriginWO, toggleWOAttachmentShow: toggleWOAttachmentShow, screenLimit: screenLimit })); }),
            isEmpty(duplicateWOList) && React.createElement("div", { className: "dsm-card mt-3" },
                React.createElement("div", { className: "dsm-card-body" },
                    React.createElement(NoData, null))),
            React.createElement("div", { className: "mt-3" },
                React.createElement("div", { className: "duplicate-submit" },
                    React.createElement(Button, { type: "secondary", block: true, className: "dsm-btn dsm-btn-secondary dsm-btn-block f16", onClick: handleJump }, "No, I have a different issue")),
                React.createElement("div", { className: "duplicate-m-submit" },
                    React.createElement(Button, { type: "secondary", block: true, className: "dsm-btn dsm-btn-primary dsm-btn-block f16", onClick: handleJump }, "No, I have a different issue")))),
        howToVideoVisible && React.createElement(HowToVideo, { thenAction: jumpAction }));
}));
var DuplicateWOItem = function (props) {
    var wo = props.wo, handleOriginWO = props.handleOriginWO, toggleWOAttachmentShow = props.toggleWOAttachmentShow, screenLimit = props.screenLimit;
    return React.createElement("div", { className: "dsm-card duplicate-item mt-3" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-6 col-sm-12 d-flex item-align item-pl" },
                wo.serviceCombinationAliasId ?
                    React.createElement(SvgImage, { iconUrl: wo.serviceCombinationAlias.serviceCodeIconUrl }) :
                    React.createElement(SvgImage, { iconUrl: '' }),
                React.createElement("div", { className: "pl-3" },
                    React.createElement("b", { className: "f16 " }, wo.aliasOrServiceComboName),
                    React.createElement("br", null),
                    React.createElement("b", { className: "f16" },
                        "WO #",
                        wo.woId))),
            React.createElement("div", { className: "col-md-6 duplicate-item-top-btn d-flex align-items-center justify-content-center item-pr" },
                React.createElement(Button, { type: "primary", onClick: function () { return handleOriginWO(wo); }, className: "dsm-btn dsm-btn-primary dsm-btn-normal dsm-btn-block f14" }, "Yes, this is the same issue"))),
        React.createElement("div", { className: "bt-divider" }),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-6 col-sm-12 item-pl" },
                React.createElement("div", null,
                    React.createElement("b", { className: "f16" }, "Description")),
                React.createElement("div", { className: "f14 mt-2" }, wo.additionalDetail ? wo.additionalDetail : 'No description...')),
            React.createElement("div", { className: "col-md-6 col-sm-12 item-pr l-divider" },
                React.createElement("div", null,
                    React.createElement("b", { className: "f16" }, "Attachments")),
                wo.attachments.length === 0 && React.createElement("div", { className: "f14 mt-2" }, "No attachments..."),
                wo.attachments.length > 0 && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "duplicate-check-photo-dragger mt-2" },
                        React.createElement(Dragger, { fileList: wo.tempAttachments, isOnlyView: true, showRemove: false, onUpload: null })),
                    wo.attachments.length > screenLimit && React.createElement("div", { className: "attach-more dsm-btn-secondary d-flex justify-content-center" },
                        React.createElement("div", { className: "d-flex align-items-center", onClick: function () { return toggleWOAttachmentShow(wo, !wo.attachmentShowAll); } }, !wo.attachmentShowAll ?
                            React.createElement(React.Fragment, null,
                                React.createElement("span", null, "See all attachments"),
                                " ",
                                React.createElement("span", { className: "attach-badge" }, wo.attachments.length)) :
                            React.createElement("span", { className: "px-5 py-2" }, "Hide")))))),
        React.createElement("div", { className: "duplicate-item-m-btn" },
            React.createElement("div", { className: "dsm-btn-secondary", onClick: function () { return handleOriginWO(wo); } }, "Yes, this is the same issue")));
};
export default DuplicateCheckList;
